module.exports = __webpack_public_path__ + "static/media/screenshot-7.77dc654f.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/screenshot-7.png
// module id = 692
// module chunks = 2